export default "/react/getBloggerIcon-bb4c8001.svg";